import { accent } from "../hooks/tokens.js";
import { COMPARE, ARTICLES } from "../data.js";

// Fiches comparatives (OSPF vs IS-IS, VLAN vs VXLAN, …).
export function buildCompareView(ctx) {
  const { s, patch, go } = ctx;
  const c = COMPARE.find((x) => x.id === s.compareId) || COMPARE[0];
  return {
    compareTabs: COMPARE.map((x) => ({ label: x.label,
      border: x.id === s.compareId ? accent : "oklch(0.92 0.008 85)",
      color: x.id === s.compareId ? accent : "oklch(0.45 0.015 60)",
      bg: x.id === s.compareId ? "oklch(0.99 0.006 60)" : "transparent",
      onClick: () => patch({ compareId: x.id }) })),
    compareA: c.a, compareB: c.b, compareVerdict: c.verdict,
    compareRows: c.rows.map((r) => ({ crit: r.crit, a: r.a, b: r.b,
      aColor: r.w === "a" ? "oklch(0.24 0.012 60)" : "oklch(0.5 0.015 60)",
      bColor: r.w === "b" ? "oklch(0.24 0.012 60)" : "oklch(0.5 0.015 60)" })),
    compareLinks: c.links.map((id) => { const a = ARTICLES.find((x) => x.id === id); return { title: a.title, onClick: () => go(id) }; }),
  };
}
